"use client"

import { Label } from "../../components/ui/label"

export function FormField({ label, required = false, children, htmlFor }) {
  return (
    <div className="space-y-3">
      <Label htmlFor={htmlFor} className="text-base font-medium text-gray-700">
        {label} {required && <span className="text-red-500">*</span>}
      </Label>
      <div className="w-full">{children}</div>
    </div>
  )
}

